/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageRoot
 */
export interface StorageRoot {
    /**
     * 
     * @type {string}
     * @memberof StorageRoot
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof StorageRoot
     */
    region: string;
}

export function StorageRootFromJSON(json: any): StorageRoot {
    return StorageRootFromJSONTyped(json, false);
}

export function StorageRootFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageRoot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
        'region': json['region'],
    };
}

export function StorageRootToJSON(value?: StorageRoot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
        'region': value.region,
    };
}


